"use strict";

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.array.reduce");

exports.__esModule = true;
exports.PLACEMENT = exports.DELAY_OPEN = void 0;

var _popper = _interopRequireDefault(require("popper.js"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var DELAY_OPEN = 250; // ms

exports.DELAY_OPEN = DELAY_OPEN;

var PLACEMENT = _popper["default"].placements.sort().reduce(function (acc, placement) {
  acc[placement] = placement;
  return acc;
}, {});

exports.PLACEMENT = PLACEMENT;